module.exports = __webpack_public_path__ + "static/media/2020-normalized.ddbc4b37.csv";